export default __webpack_public_path__ + "static/media/more1.86c45457.jpg";